// Types

import type { DealsPaginationData, DxgDeal } from '@makemydeal/dr-sales-checkin-types';
import type { DealsState } from './types';

export const getInitialDealState = (): DealsState => ({
    isDealsFetching: false,
    dealsPaginationData: {} as DealsPaginationData,
    dxgDeal: {} as DxgDeal,
    selectedDxgVehicle: undefined
});
